import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import DropdownMenu from './DropdownMenu';
import Link from './Link';
import { groupLinks } from '../../../../../modules/navigation/services/links';
import { isMobile } from '../../../../../services/browser';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../services/proptypes';
var defaultProps = {
  linksAs: 'a'
};
function Links(_ref) {
  var links = _ref.links,
    linksAs = _ref.linksAs;
  if (_isEmpty(links)) {
    return null;
  }
  var transformedLinks = groupLinks(links);
  if (isMobile()) {
    transformedLinks = [].concat(_toConsumableArray(transformedLinks.filter(function (link) {
      return link.as !== 'Button';
    })), _toConsumableArray(transformedLinks.filter(function (link) {
      return link.as === 'Button';
    })));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, transformedLinks.map(function (link) {
    if (link.links) {
      return /*#__PURE__*/React.createElement(DropdownMenu, {
        key: "".concat(link.title, "-").concat(link.links.length),
        title: link.title,
        options: link.links,
        linksAs: linksAs
      });
    }
    return /*#__PURE__*/React.createElement(Link, _extends({
      key: "".concat(link.title, "-").concat(link.url, "-").concat(link.slug)
    }, link));
  }));
}
Links.defaultProps = defaultProps;
export default Links;